
import { PDFDocument } from 'pdf-lib';
import { FPI_PDF_MAP } from './languageUtils';

/**
 * Merge survey PDF with FPI PDF
 */
export const mergePDFs = async (
  language: string,
  surveyPdfBytes: ArrayBuffer
): Promise<Blob> => {
  try {
    // Get FPI PDF path
    const fpiPdfPath = FPI_PDF_MAP[language];
    if (!fpiPdfPath) {
      throw new Error(`No FPI PDF found for language: ${language}`);
    }

    // Fetch the FPI PDF
    const fpiPdfResponse = await fetch(fpiPdfPath);
    if (!fpiPdfResponse.ok) {
      throw new Error(`Could not load FPI PDF for language ${language}: ${fpiPdfResponse.statusText}`);
    }
    const fpiPdfBytes = await fpiPdfResponse.arrayBuffer();

    // Create a new PDF document
    const mergedPdf = await PDFDocument.create();
    
    // Load both PDFs
    const surveyPdfDoc = await PDFDocument.load(surveyPdfBytes);
    const fpiPdfDoc = await PDFDocument.load(fpiPdfBytes);
    
    // First copy the FPI PDF pages to the merged PDF
    const fpiPageIndices = fpiPdfDoc.getPageIndices();
    const fpiPages = await mergedPdf.copyPages(fpiPdfDoc, fpiPageIndices);
    fpiPages.forEach(page => mergedPdf.addPage(page));
    
    // Then copy survey pages to the merged PDF
    const surveyPageIndices = surveyPdfDoc.getPageIndices();
    const surveyPages = await mergedPdf.copyPages(surveyPdfDoc, surveyPageIndices);
    surveyPages.forEach(page => mergedPdf.addPage(page));
    
    // Save and return the merged PDF as blob
    const mergedPdfBytes = await mergedPdf.save();
    return new Blob([new Uint8Array(mergedPdfBytes)], { type: 'application/pdf' });
  } catch (error) {
    console.error("Error merging PDFs:", error);
    throw error;
  }
};

/**
 * Download the generated PDF
 */
export const downloadPDF = (blob: Blob, language: string, selectedSurvey: string): void => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `FPI_survey_${language}_${selectedSurvey}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
